
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

export default {
name: 'ApplyTryPage',
components: {
XInput,
XButton,
Group,
Cell,
Msg,
Checklist
},
data () {
return {
formParam: {
mobile: '',
contact: '',
companyName: '',
email: '',
items: ''
},
selectList: [],
commonList: [
{key: '行业资讯', value: '行业资讯'},
{key: '基础资料', value: '基础资料'},
{key: '进口管理', value: '进口管理'},
{key: '出口管理', value: '出口管理'},
{key: '设备管理', value: '设备管理'},
{key: '财务和费用', value: '财务和费用'},
{key: '仓库管理', value: '仓库管理'},
{key: '加工贸易（金二）', value: '加工贸易（金二）'},
{key: '辅助核销（金二）', value: '辅助核销（金二）'},
{key: '管理中心', value: '管理中心'},
{key: '数据下载和比对', value: '数据下载和比对'}
]
}
},
methods: {
submitApply: function () {
let that = this
let url = '/wxapi/user/submitApplyTryEsmart'
that.formParam.items = that.selectList.join(',')
this.$axios.post(url, {}, {params: that.formParam}).then(function (res) {
if (res.meta.success) {
that.$Msgbox.alert('提交成功！')
} else {
console.error(res.meta.message)
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}).catch(function (error) {
console.info(error)
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/user/ApplyTryPageEsmart.vue